import { Reference, Property, Name, Text } from '@components/Reference';
import Sandbox from '@components/Sandbox';
import Cell from '@components/Cell';
import { Spacer, Container, Row, Col } from '@cleartrip/bento/lib';
import * as React from 'react';
export default {
  Reference,
  Property,
  Name,
  Text,
  Sandbox,
  Cell,
  Spacer,
  Container,
  Row,
  Col,
  React
};